import { LoginStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const yupLoginLandingValidationSchema = {
  [LoginStepFormFieldsEnum.WorkerId]: yupLanding.string().required(),
  [LoginStepFormFieldsEnum.Phone]: yupLanding.string().required(),
};
